import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import classNames from "classnames";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import styleConstants from "../../styleConstants";

const plotAreaHorizontalMargin = 10;

const styles = {
  container: {
    fontSize: "0.875rem"
  }
};

const SmallLineChart = props => {
  let options = {
    chart: {
      type: "line",
      backgroundColor: null,
      style: {
        fontFamily: "'Source Sans Pro', sans-serif;"
      },
      marginLeft: props.marginLeft + plotAreaHorizontalMargin,
      marginRight: plotAreaHorizontalMargin,
      width: props.width,
      height: 300
    },
    title: {
      text: props.title,
      style: {
        fontSize: "0.875rem"
      },
      x: props.yAxis.showLabels ? 28 : undefined
    },
    plotOptions: {
      series: {
        lineWidth: 3,
        dashStyle: "shortDot",
        zoneAxis: "x",
        zones: [
          {
            value: 2025,
            dashStyle: "solid"
          }
        ]
      }
    },
    xAxis: {
      min: 2020,
      max: 2030,
      tickInterval: 10,
      tickLength: 0,
      minorTickLength: 0,
      lineColor: styleConstants.colors.gray6,
      gridLineColor: styleConstants.colors.gray4,
      labels: {
        style: {
          fontSize: "0.875rem",
          color: styleConstants.colors.gray4
        }
      }
    },
    yAxis: {
      title: {
        text: props.yAxis.title
      },
      min: props.yAxis.minimum,
      max: props.yAxis.maximum,
      labels: {
        style: {
          fontSize: "0.875rem",
          color: styleConstants.colors.gray4
        },
        enabled: props.yAxis.showLabels
      },
      lineColor: styleConstants.colors.gray4,
      gridLineDashStyle: "ShortDot",
      gridLineColor: styleConstants.colors.gray4
    },
    series: [
      {
        ...props.series[0],
        marker: {
          lineWidth: 3,
          lineColor: props.series.color,
          fillColor: "white"
        }
      }
    ],
    tooltip: {
      maxWidth: 500,
      backgroundColor: "white",
      useHTML: true,
      outside: true,
      formatter: props.tooltipFormatter,
      style: {
        fontSize: "0.875rem",
        color: styleConstants.colors.gray6
      },
      enabled: !!props.tooltipFormatter
    },
    legend: {
      enabled: false
    },
    exporting: {
      enabled: false
    },
    credits: {
      enabled: false
    }
  };

  return (
    <div className={classNames(props.classes.container, props.className)}>
      <HighchartsReact
        ref={props.onRegisterChartRef}
        highcharts={Highcharts}
        options={options}
      />
    </div>
  );
};

SmallLineChart.propTypes = {
  title: PropTypes.string,
  marginLeft: PropTypes.number,
  width: PropTypes.number.isRequired,
  yAxis: PropTypes.shape({
    title: PropTypes.string,
    minimum: PropTypes.number,
    maximum: PropTypes.number,
    showLabels: PropTypes.bool
  }),
  series: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired
    })
  ).isRequired,
  tooltipFormatter: PropTypes.func,
  className: PropTypes.string,
  onRegisterChartRef: PropTypes.func
};

SmallLineChart.defaultProps = {
  yAxis: {},
  tooltipFormatter: function(tooltip) {
    return tooltip.defaultFormatter.call(this, tooltip);
  }
};

export default withStyles(styles)(SmallLineChart);
